/**
 * Имена cookie и ключей localStorage — те же, что в веб-версии (§3 LOGIC.md),
 * чтобы состояние переносилось между проектами без сюрпризов.
 */

/** Cookie: нужны прокси и бэкенду, живут 30 дней */
export const USER_ID_COOKIE = 'user-id'
export const REGION_COOKIE = 'region'
export const RESTAURANT_COOKIE = 'restaurantId'
export const LONGITUDE_COOKIE = 'longitude'
export const LATITUDE_COOKIE = 'latitude'
export const DELIVERY_COOKIE = 'delivery'
/** Человеческий адрес выбранной точки — по координатам его не восстановить */
export const ADDRESS_COOKIE = 'address'
/**
 * Запись справочника, которую выбрал клиент. Хранится рядом с координатами:
 * без неё адрес приходилось угадывать по расстоянию, и заказ уезжал то к
 * соседней записи, то вовсе без подъезда и этажа.
 */
export const ADDRESS_ID_COOKIE = 'address-id'
export const TG_ID_COOKIE = 'tg_id'
/**
 * Клиент сам вышел из аккаунта. Пока флаг стоит, молчаливый вход через бота
 * не срабатывает — иначе в Telegram выход отменялся бы следующим же запуском.
 */
export const LOGGED_OUT_COOKIE = 'logged-out'

/** localStorage: чисто клиентские данные */
export const BASKET_KEY = 'basket'

/**
 * sessionStorage: метка одного захода в мини-апп для телеметрии. Живёт
 * ровно пока открыта вкладка — её и переживает перезагрузка страницы.
 */
export const SESSION_KEY = 'telemetry-session'
